import { render, staticRenderFns } from "./CButtonFeedback.vue?vue&type=template&id=45df6674"
import script from "./CButtonFeedback.vue?vue&type=script&lang=js"
export * from "./CButtonFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports